/* eslint-disable react/display-name */
import type { ReactElement } from "react"

import { ETypographyFamily, ETypographySize, ETypographyTag, ETypographyWeight, Typography } from "@/3514/components"
import { type IUseTranslation, type TTranslationKeys, useTranslation } from "@/hooks"

import classes from "../styles"

export default ({ textKey }: { textKey: keyof TTranslationKeys }): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <Typography
            text={t(textKey)}
            family={ETypographyFamily.DmSerif}
            weight={ETypographyWeight.Medium}
            size={ETypographySize.Heading2}
            tag={ETypographyTag.Heading2}
            className={classes.elements.title()}
        />
    )
}
